// extracted by mini-css-extract-plugin
module.exports = {"label":"label__2Nf1u","danger":"danger__3bQt4","secondary":"secondary__6cY8k"};